import { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectableContext from '../../../contexts/local/selectable/SelectableContext';
import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import Loading from '../../ui-elements/Loading';
import Channel from '../discarding/panel/Channel';
import Panel from '../discarding/panel/Panel';
import PlantBlockSelectable from '../discarding/panel/PlantBlockSelectable';
import BackButton from '../../layout/BackButton';

const PanelSlotSelection = ({ forwardTo, harvesting }) => {
    const { additionalProcessInformation, loadOccupancy, occupancyArray, continueProcess, activeProcessId } =
        useContext(ProcessContext);
    const { loading } = useContext(UIContext);
    const { selection, Sidebar, isSelecting } = useContext(SelectableContext);
    const [showContinueButton, setShowContinueButton] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (selection.length > 0 && !isSelecting) {
            setShowContinueButton(true);
        } else if (isSelecting) {
            setShowContinueButton(false);
        }
    }, [selection, isSelecting]);

    const load = async () => {
        await loadOccupancy(additionalProcessInformation.sourceEntity, 'panel');
    };

    useEffect(() => {
        const taskSlots = additionalProcessInformation?.context?.selectedPlantSlotOrdinalNumbers ?? [];
        if (taskSlots.length > 0) {
            continueProcess(activeProcessId, taskSlots)
                .catch(console.error);
        }
    }, [additionalProcessInformation?.context?.selectedPlantSlotOrdinalNumbers]);

    const proceedToConfirmation = async () => {
        try {
            await continueProcess(activeProcessId, selection);
            if(!harvesting) {
                navigate(forwardTo);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return loading ? (
        <Loading fullScreen/>
    ) : (
        <Fragment>
            {Sidebar}
            <BackButton/>
            <Panel alignment='horizontal'>
                {occupancyArray.map((channel) => (
                    <Channel key={channel.channelNumber} channel={channel}>
                        {channel.plantSlotBlocks.map((block, index) => (
                            <PlantBlockSelectable
                                key={`${channel.channelNumber}-${block.startPlantSlotOrdinalNumber}-${block.endPlantSlotOrdinalNumber}`}
                                block={block}
                                channelNr={channel.channelNumber}
                                index={index}
                                disabled={!block.isOccupied}
                                hideContent={!block.isOccupied}
                                endOfLife={additionalProcessInformation?.endOfLife}
                                style={{
                                    width: (block.endPlantSlotOrdinalNumber - block.startPlantSlotOrdinalNumber + 1) / (parseInt(import.meta.env.VITE_PANELSETTINGS_TOTALPLANTSLOTSPERCHANNEL) / 100) + '%',
                                }}
                                harvesting={harvesting}
                            />
                        ))}
                    </Channel>
                ))}
            </Panel>
            {showContinueButton && (
                <Fragment>
                    <StatusBarButton
                        label='Continue'
                        icon='fas fa-chevron-right'
                        reversed={true}
                        clickHandler={proceedToConfirmation}
                        statusSlot={5}
                    />
                </Fragment>
            )}
        </Fragment>
    );
};

export default PanelSlotSelection;